import styled from 'styled-components';

/** TODO: fix padding bottom to be dynamic */
const Guide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem 1rem;
  margin: 0;
  width: 100%;
  height: 100%;
`;

export default Guide;
